
export type SseEvent = { event: string; data: string }

type SseParser = {
  push: (chunk: string) => void
}

export function createSseParser(emit: (event: SseEvent) => void): SseParser {
  let buffer = ''
  let eventName = ''
  let dataLines: string[] = []

  function line(text: string) {
    if (text === '') {
      if (eventName !== '' || dataLines.length > 0) {
        emit({ event: eventName || 'message', data: dataLines.join('\n') })
      }
      eventName = ''
      dataLines = []
      return
    }
    if (text.startsWith(':')) return
    const colon = text.indexOf(':')
    const field = colon === -1 ? text : text.slice(0, colon)
    let value = colon === -1 ? '' : text.slice(colon + 1)
    if (value.startsWith(' ')) value = value.slice(1)
    if (field === 'event') eventName = value
    else if (field === 'data') dataLines.push(value)
  }

  return {
    push(chunk) {
      buffer += chunk
      for (;;) {
        const match = /\r\n|\r|\n/.exec(buffer)
        if (!match) return
        if (match[0] === '\r' && match.index === buffer.length - 1) return
        line(buffer.slice(0, match.index))
        buffer = buffer.slice(match.index + match[0].length)
      }
    },
  }
}
